/** Regex function that checks string value for zip format
 * I.e.  12345 or 12345-6789
 * @param str
 * @returns {bool}
 */
export const isUSAZipCode = (str) => {
  return /^[0-9]{5}(?:-[0-9]{4})?$/.test(str);
};
